import React from 'react';
import MainToggle from '@wix/da-ds/pkg/formControls/dsPresets/MainToggle';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { usePushSubscription } from '../../../../redux/pwa/hooks';
export function usePushSubscriptionItem() {
    const pwa = useFlag('pwa');
    const subscription = usePushSubscription();
    return pwa && {
        label: 'Subscribe to push notifications',
        suffix: /*#__PURE__*/ React.createElement(MainToggle, {
            variant: "main",
            size: "medium",
            "aria-label": "Subscribe to push notifications",
            value: subscription.isSubscribed,
            onChange: (val)=>{
                subscription.toggleSubscription();
            },
            disabled: !subscription.canToggle
        })
    };
}

//# sourceMappingURL=usePushSubscriptionItem.js.map